import type { MetaTag, OpenGraphMetaOptions, SeoMetaData } from "@/lib/seo-meta";

export function appendOpenGraphImageMetaTags(
  meta: MetaTag[],
  data: SeoMetaData,
  image: OpenGraphMetaOptions["image"],
): void {
  if (image === false) return;
  if (!data.imageUrl) return;

  meta.push({ property: "og:image", content: data.imageUrl });
  if (image?.width) meta.push({ property: "og:image:width", content: image.width });
  if (image?.height) meta.push({ property: "og:image:height", content: image.height });
  if (image?.alt) meta.push({ property: "og:image:alt", content: image.alt });
}
